import React from "react";

const PaymentFailure = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>
          <span>&#10060;</span>
        </div>
        <h1 style={styles.title}>Payment Failed!</h1>
        <p style={styles.message}>
          Oops! Something went wrong. Please try again later or contact support.
        </p>
        <button
          style={styles.button}
          onClick={() => {
            window.location = "/search";
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#ffe6e6",
  },
  card: {
    textAlign: "center",
    backgroundColor: "#ffffff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  icon: {
    fontSize: "50px",
    color: "#e74c3c",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    color: "#333333",
    marginBottom: "10px",
  },
  message: {
    fontSize: "16px",
    color: "#666666",
  },
  button: {
    marginTop: "20px",
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#e74c3c",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default PaymentFailure;
